import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure, Button, Text, IconButton, Stack, Icon, Heading, Input, TableContainer, Table, Thead, Tr, Th, Tbody, Td, Checkbox, Select } from '@chakra-ui/react';
import { useState } from 'react';
import { AiOutlineEdit } from 'react-icons/ai';
import { FaCheck, FaUserEdit } from 'react-icons/fa';
import { IoMdClose } from 'react-icons/io';

export default function EditUserButton() {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [checkedItems, setCheckedItems] = useState([false, false])

    const allChecked = checkedItems.every(Boolean)
    const isIndeterminate = checkedItems.some(Boolean) && !allChecked

    return (
        <>
            <IconButton
                aria-label="Edit User"
                icon={<AiOutlineEdit />}
                color={'gray.800'}
                bg={'transparent'}
                fontSize={'xl'}
                rounded={'full'}
                onClick={onOpen}
            />
            <Modal isCentered isOpen={isOpen} onClose={onClose} size={'3xl'}>
                <ModalOverlay
                    bg='blackAlpha.300'
                    backdropFilter='blur(10px)'
                />
                <ModalContent>
                    <ModalHeader
                        as={Stack}
                        direction={'row'}
                        borderBottom={'2px'}
                        borderBottomColor={'gray.300'}
                    >
                        <Icon
                            as={FaUserEdit}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={0}>
                            <Heading fontSize={'xl'}>Edit User</Heading>
                            <Text fontSize={'sm'}>Invite your team members, accountants or bookkeepers.</Text>
                        </Stack>
                        <ModalCloseButton rounded={'full'} />
                    </ModalHeader>
                    <ModalBody as={Stack} spacing={4} py={8}>
                        <Stack direction={'row'} spacing={4}>
                            <Input type={'text'} size={'md'} placeholder={'Name'} />
                            <Input type={'text'} size={'md'} placeholder={'Email Address'} />
                        </Stack>
                        <Select placeholder='Organization Type' w={'100%'}>
                            <option value='option1'>Organization User</option>
                            <option value='option2'>Organization Account Owner</option>
                            <option value='option2'>Organization User (Business Specific)</option>
                        </Select>
                        <TableContainer>
                            <Table size='md' variant='striped'>
                                <Thead>
                                    <Tr>
                                        <Th>
                                            <Checkbox
                                                isChecked={allChecked}
                                                isIndeterminate={isIndeterminate}
                                                onChange={(e) => setCheckedItems([e.target.checked, e.target.checked])}
                                            >
                                                Entity Name
                                            </Checkbox>
                                        </Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    <Tr>
                                        <Td>
                                            <Checkbox
                                                isChecked={checkedItems[0]}
                                                onChange={(e) => setCheckedItems([e.target.checked, checkedItems[1]])}
                                            >
                                                Inam Space Research Organization
                                            </Checkbox>
                                        </Td>
                                    </Tr>
                                    <Tr>
                                        <Td>
                                            <Checkbox
                                                isChecked={checkedItems[1]}
                                                onChange={(e) => setCheckedItems([checkedItems[0], e.target.checked])}
                                            >
                                                Insight Ways Private Limited
                                            </Checkbox>
                                        </Td>
                                    </Tr>
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </ModalBody>
                    <ModalFooter
                        as={Stack}
                        direction={'row'}
                        spacing={4}
                        borderTop={'2px'}
                        borderTopColor={'gray.300'}
                    >
                        <Button onClick={onClose} leftIcon={<IoMdClose />}>Close</Button>
                        <Button onClick={onClose} leftIcon={<FaCheck />} colorScheme={'primary'}>Save</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    )
}